module.exports = __webpack_public_path__ + "static/media/halloween_small.518f0e77.jpg";